import { ExternalIdentifierEntity, ExternalSyncAction, OAuthIntegrationType } from 'api/types/globalTypes';
import { FilterOption } from 'components/datagrid/filter/types';

export const integrationTypeLabels: Record<OAuthIntegrationType, string> = {
  [OAuthIntegrationType.UtilizeCore]: 'UtilizeCore',
};

/** Procursys record → what it becomes in UtilizeCore */
export const entityLabels: Record<ExternalIdentifierEntity, string> = {
  [ExternalIdentifierEntity.ServiceProvider]: 'Vendor (SP)',
  [ExternalIdentifierEntity.PropertyOwner]: 'Client (property owner)',
  [ExternalIdentifierEntity.Location]: 'Location (site)',
};

export const actionLabels: Record<ExternalSyncAction, string> = {
  [ExternalSyncAction.Created]: 'Created',
  [ExternalSyncAction.Matched]: 'Matched',
  [ExternalSyncAction.AlreadyLinked]: 'Already linked',
  [ExternalSyncAction.Skipped]: 'Skipped',
  [ExternalSyncAction.Failed]: 'Failed',
};

export const actionColors: Record<ExternalSyncAction, 'success' | 'info' | 'default' | 'error'> = {
  [ExternalSyncAction.Created]: 'success',
  [ExternalSyncAction.Matched]: 'info',
  [ExternalSyncAction.AlreadyLinked]: 'default',
  [ExternalSyncAction.Skipped]: 'default',
  [ExternalSyncAction.Failed]: 'error',
};

// filters take the stored (database) values, which differ from the GraphQL enum keys
export const entityFilterOptions: FilterOption[] = [
  { key: 'ServiceProvider', label: entityLabels.ServiceProvider },
  { key: 'PropertyOwner', label: entityLabels.PropertyOwner },
  { key: 'Location', label: entityLabels.Location },
];

export const actionFilterOptions: FilterOption[] = [
  { key: 'created', label: 'Created' },
  { key: 'matched', label: 'Matched' },
  { key: 'already_linked', label: 'Already linked' },
  { key: 'skipped', label: 'Skipped' },
  { key: 'failed', label: 'Failed' },
];

export type SyncStatus = 'synced' | 'partial' | 'failed';

export const syncStatusChips: Record<SyncStatus, { label: string; color: 'success' | 'warning' | 'error' }> = {
  synced: { label: 'Synced', color: 'success' },
  partial: { label: 'Partially failed', color: 'warning' },
  failed: { label: 'Failed', color: 'error' },
};

export const syncStatusFilterOptions: FilterOption[] = [
  { key: 'synced', label: 'Synced' },
  { key: 'partial', label: 'Partially failed' },
  { key: 'failed', label: 'Failed' },
];
